import { useState, useEffect } from 'react';
import PaymentService from 'services/PaymentService';
import { useAuthUser } from 'features/auth/AuthUserContext';

export default function useStripeSubscription() {
  const [subscription, setSubscription] = useState(null);
  const { isAuthenticated } = useAuthUser();
  const paymentService = new PaymentService();

  useEffect(() => {
    async function fetchStripeSubscription() {
      try {
        const response = await paymentService.getStripeSubscription();

        if (response.data) {
          setSubscription(response.data);
        }
      } catch (e) {
        console.error(e);
      }
    }

    if (isAuthenticated) {
      fetchStripeSubscription();
    }
  }, [isAuthenticated]);

  return subscription;
}
